import dayjs, { type Dayjs } from 'dayjs'

/**
 * The last `days` whole days, today included: midnight `days - 1` ago through
 * the end of today. Whole days rather than a rolling `days * 24h` window, so a
 * range picked by date covers every hour of the dates picked.
 */
export function lastDays(days: number): [Dayjs, Dayjs] {
  const today = dayjs()
  return [today.subtract(days - 1, 'day').startOf('day'), today.endOf('day')]
}
